<template>
	<div class="zw profile">
		<div class="user">
			<span>{{ FullName }}</span>
		</div>
		<div class="options">
			<router-link tag="div" to="/dashboard" class="ui button" @click.native="closeSidebar">
				<i class="home icon"/>
				{{ $t('sidebar.profile.home') }}
			</router-link>
			<router-link tag="div" to="/profile" class="ui button" @click.native="closeSidebar">
				<i class="user icon"/>
				{{ $t('sidebar.profile.profile') }}
			</router-link>
			<button class="ui red button large" @click="showLogout()">
				<i class="remove user icon"/>
				{{ $t('sidebar.profile.logout') }}
			</button>
		</div>

		<semantic-modal v-model="showModal" :settings="{content_classes: {content: false}, closeable: true, closeable_button: false}" class="basic small">
			<div class="ui icon header" slot="header">
				<i class="home icon"/>
				{{ $t('modals.logout.areyousure') }}
			</div>
			<div class="actions" slot="actions">
				<div class="ui red basic cancel inverted button">{{ $t('globals.buttons.no') }}</div>
				<div class="ui green ok inverted button" @click="logOut()">{{ $t('globals.buttons.yes') }}</div>
			</div>
		</semantic-modal>
	</div>
</template>

<script>
	export default {
		name: 'SidebarProfile',

		data () {
			return {
				showModal: false
			}
		},

		computed: {
			FullName () {
				return this.$auth.user().firstname + ' ' + this.$auth.user().surname
			}
		},

		methods: {
      closeSidebar () {
        let sidebar = $('.ui.sidebar')

        if (window.innerWidth <= 1200 && sidebar.hasClass('visible')) {
          sidebar.sidebar('toggle');
        }
      },

			showLogout () {
				this.showModal = true
			},

			logOut () {
				this.$auth.logout({
					makeRequest: true,
					redirect: {name: 'login'}
				})

				// Reset merchants from store -- In addition to vuex-persisted-state
				this.$store.dispatch('resetMerchants')
				this.$store.dispatch('resetMerchant')
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/layout/SidebarProfile.vue